import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
  menuId: number;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, menuId }) => {
  const { isMaster, canView } = usePermissions();

  // Se for MASTER, tem acesso total
  if (isMaster) {
    return <>{children}</>;
  }

  // Se não tem permissão de visualizar para este menu, redireciona para dashboard
  if (!canView(menuId)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}; 